import { FC, useState } from 'react'
import Select from '../../../control/select/select'
import { Grid, Paper } from '@material-ui/core'
import Button from '../../../control/button/button'
import { Form } from 'react-final-form'
import { makeStyles } from '@material-ui/core/styles'

import useTranslate from '../../../i18n/useTranslate'
import { KeywordType } from '../../../services/um/useSearchSettingFaculty'
import useIRB from '../../../services/um/lookups/useIRB'

interface PanelProps {
    onSubmit: (values: KeywordType) => void
    initialSearch: any
}

const Panel: FC<PanelProps> = ({ initialSearch, onSubmit }) => {
    const translate = useTranslate()
    const classes = useStyles()
    const { irb } = useIRB()
    const defaultSelect = initialSearch.recID ? [initialSearch.recID] : undefined

    return (
        // <Paper className={classes.paperSearch}>
        <Form onSubmit={onSubmit} initialValues={initialSearch}>
            {({ handleSubmit }) => {
                return (
                    <Grid container className={classes.root} spacing={2} alignItems="flex-end">
                        <Grid item xs={12} md={6}>
                            <Select
                                name="recID"
                                option={[
                                    {
                                        value: null,
                                        label: translate.get('LABEL.NOT_SPECIFIC'),
                                    },
                                    ...irb,
                                ]}
                                label={translate.get('UM.SETTING_FACULTY.REC')}
                                placeholder={translate.get('UM.SETTING_FACULTY.REC')}
                                size="small"
                                defaultValue={defaultSelect}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Grid container justify="flex-end">
                                <Grid item>
                                    <Button
                                        size={'large'}
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        className={classes.btnSearch}
                                        onClick={handleSubmit}
                                    >
                                        {translate.get('UM.EXTERNAL-RESEARCHER.SEARCH')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                )
            }}
        </Form>

        // </Paper>
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        padding: '15px',
    },

    clear: {
        textDecoration: 'underline',
        cursor: 'pointer',
        padding: '0px 1.5rem',
        alignSelf: 'center',
    },
    paperSearch: {
        width: '100%',
        padding: theme.spacing(3),
        paddingBottom: '32px',
        marginBottom: '10px',
    },
    btnSearch: {
        boxShadow: `0px 4px 4px ${theme.palette.grey['50']}`,
    },
}))

export default Panel
